import { render } from "./instructor-setting-notifications.vue?vue&type=template&id=5909583a"
import script from "./instructor-setting-notifications.vue?vue&type=script&lang=js"
export * from "./instructor-setting-notifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__